import React from 'react';
import Icon from '../../../components/AppIcon';

const PostEngagement = ({ post, onLike, onComment, onShare, onSave, isLiked, isSaved }) => {
  return (
    <div className="border-y border-border bg-card">
      <div className="flex items-center justify-between p-4 md:p-6">
        <div className="flex items-center gap-6 md:gap-8">
          <button
            onClick={onLike}
            className="flex items-center gap-2 touch-target group"
            aria-label={isLiked ? "Unlike post" : "Like post"}
          >
            <Icon
              name="Heart"
              size={24}
              color={isLiked ? "var(--color-error)" : "currentColor"}
              fill={isLiked ? "var(--color-error)" : "none"}
              className={`transition-base ${isLiked ? 'text-error' : 'text-muted-foreground group-hover:text-error'}`}
            />
            <span className={`caption font-medium ${isLiked ? 'text-error' : 'text-muted-foreground group-hover:text-error'}`}>
              {post?.likes?.toLocaleString()}
            </span>
          </button>

          <button
            onClick={onComment}
            className="flex items-center gap-2 touch-target group"
            aria-label="Comment on post"
          >
            <Icon
              name="MessageCircle"
              size={24}
              className="text-muted-foreground group-hover:text-primary transition-base"
            />
            <span className="caption font-medium text-muted-foreground group-hover:text-primary transition-base">
              {post?.comments?.toLocaleString()}
            </span>
          </button>

          <button
            onClick={onShare}
            className="flex items-center gap-2 touch-target group"
            aria-label="Share post"
          >
            <Icon
              name="Share2"
              size={24}
              className="text-muted-foreground group-hover:text-primary transition-base"
            />
            <span className="caption font-medium text-muted-foreground group-hover:text-primary transition-base hidden md:inline">
              Share
            </span>
          </button>
        </div>

        <button
          onClick={onSave}
          className="touch-target"
          aria-label={isSaved ? "Unsave post" : "Save post"}
        >
          <Icon
            name="Bookmark"
            size={24}
            fill={isSaved ? "currentColor" : "none"}
            className={`transition-base ${isSaved ? 'text-primary' : 'text-muted-foreground hover:text-primary'}`}
          />
        </button>
      </div>
    </div>
  );
};

export default PostEngagement;